define((require) => {
    "use strict";

    var SocialSharingWidgetModel = require("shared/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetModel");

    /**
     * @class {SocialSharingWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return SocialSharingWidgetModel.mixin("SocialSharingWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function() {
            return this.get("networks") && this.get("networks").length
                ? `Social: ${this.get("networks").join(", ")}`
                : null;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetModelEditorMixin.js